import styled from "styled-components";

export const HistoryRecordAmountsContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 10px;

    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        width: 235px;
        margin-left: 40px;
    }
`
